import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import LoadingSpinner from "../../../components/LoadingSpinner";

export default function PolicyModal({ cancelModal, clubId, fetchData }) {
  const [content, setContent] = useState("");
  const [created, setCreated] = useState("");
  const [updated, setUpdated] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [complete, setComplete] = useState(false);

  const { user } = useAuthContext();

  const fetchPolicy = async () => {
    try {
      const res = await axios.get(
        `${ApiConnectionString}/api/clubPolicy/${clubId}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (res.status === 200) {
        setContent(res.data.policyContent || "");
        setCreated(res.data.policyCreated || null);
        setUpdated(res.data.policyUpdated || null);
      }
    } catch (err) {
      setMessage("Failed to load policy.");
    } finally {
      setLoading(false);
    }
  };

  const agreeToTerms = async () => {
    setLoading(true)
    try {
      const res = await axios.post(
        `${ApiConnectionString}/api/PolicyAgreement`,
        { clubId },
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (res.status === 200) {
        fetchData();
        setComplete(true);
      } else {
        setMessage("Could not record your agreement.");
      }
    } catch (err) {
      setMessage("An error occurred while agreeing to the policy.");
    } finally{
        setLoading(false)
    }
  };

  useEffect(() => {
    fetchPolicy();
  }, []);
  if (loading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal text-center">
          <div className="blueBanner"></div>
          <div className="p-4">
            <LoadingSpinner />
          </div>
        </div>
      </div>
    );
  }

  if (complete) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal text-center">
          <div className="blueBanner">
            <p className="fw-bold m-2 p-2 fontSize20">Club Policy</p>
          </div>
          <div className="p-4">
            <p className="fw-bold">Thanks for agreeing to the club policy.</p>
            <button onClick={cancelModal} className="saveChanges-button mt-3">
              Close
            </button>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <div className="blueBanner">
            <p className="fw-bold m-2 p-2 fontSize20">Club Policy</p>
          </div>

          <button
            type="button"
            className="close-button"
            onClick={cancelModal}
            aria-label="Close"
          >
            &times;
          </button>

          <div className="p-3">
            {loading ? (
              <p>Loading...</p>
            ) : (
              <>
                {message && <p className="text-danger">{message}</p>}
                <div className="mb-3" style={{ whiteSpace: "pre-wrap" }}>
                  {content}
                </div>
                <p className="text-muted small">
                  Created:{" "}
                  {created ? new Date(created).toLocaleString() : "N/A"}
                  <br />
                  Last Updated:{" "}
                  {updated ? new Date(updated).toLocaleString() : "N/A"}
                </p>
              </>
            )}
          </div>

          <div className="send-modal-footer">
            <button onClick={agreeToTerms} className="saveChanges-button">
              Agree
            </button>
            <button
              onClick={cancelModal}
              className="pointer cancelButton fw-bold mx-2 px-3"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    );
  }
}
